import React from "react";
import Button from "./Button";
import { Flex } from "theme-ui";
import { buttons } from "../../gatsby-plugin-theme-ui/variants/buttons";
import { ButtonProps, ButtonVariantProps } from "../../../custom";

interface HeroButtonsProps {
  button1: ButtonProps;
  button2: ButtonProps;
  buttonFlexDirection: string;
}

const HeroButtons = ({
  button1,
  button2,
  buttonFlexDirection,
}: HeroButtonsProps) => {
  return (
    <Flex
      sx={{
        flexDirection: ["row", null, buttonFlexDirection],
        gap: 3,
        flexWrap: "wrap",
        // mt: buttonFlexDirection ? 3 : 0,
        mb: [0, null, null, null, "0px"],
        alignItems: [buttonFlexDirection ? buttonFlexDirection : "center"],
        justifyContent: "center",
      }}
    >
      <Button
        sx={{
          ml: "0px",
          width: "fit-content",
        }}
        {...button1}
      />
      <Button
        sx={{
          width: "fit-content",
        }}
        {...button2}
      />
    </Flex>
  );
};

export default HeroButtons;
